/* KHUN CLUB · guía ¿Dónde ver?: búsqueda y filtros (plataforma, gratis, subtítulos en español).
   Las filas ya vienen agrupadas y ordenadas desde Liquid; aquí solo se ocultan las que no coinciden.
   Estado en la URL (?q=pluto&plataforma=youtube,netflix&gratis=1&es=1) para compartirlo. */
(() => {
  const raiz = document.querySelector('[data-kc-dv]');
  if (!raiz) return;

  const $ = (sel) => raiz.querySelector(sel);
  const normalizar = (texto) =>
    String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

  const form = $('[data-kc-dv-filtros]');
  const buscar = $('[data-kc-dv-q]');
  const conteo = $('[data-kc-dv-conteo]');
  const vacio = $('[data-kc-dv-vacio]');
  const tabla = raiz.querySelector('.kc-tabla-wrap');
  const grupos = [...raiz.querySelectorAll('tbody[data-grupo]')].map((tbody) => ({
    tbody,
    n: tbody.querySelector('[data-kc-dv-n]'),
    filas: [...tbody.querySelectorAll('tr[data-pl]')].map((tr) => ({
      tr,
      pl: tr.dataset.pl,
      g: tr.dataset.g === '1',
      es: tr.dataset.es === '1',
      q: normalizar(tr.dataset.q),
    })),
  }));
  const plataformas = new Set([...form.querySelectorAll('[name="plataforma"]')].map((i) => i.value));
  const estado = { q: '', plataformas: [], gratis: false, es: false };

  function leerURL() {
    const p = new URLSearchParams(location.search);
    estado.q = p.get('q') ?? '';
    estado.plataformas = (p.get('plataforma') ?? '').split(',').filter((v) => plataformas.has(v));
    estado.gratis = p.get('gratis') === '1';
    estado.es = p.get('es') === '1';
  }

  function escribirURL(nueva) {
    const p = new URLSearchParams();
    if (estado.q) p.set('q', estado.q);
    if (estado.plataformas.length) p.set('plataforma', estado.plataformas.join(','));
    if (estado.gratis) p.set('gratis', '1');
    if (estado.es) p.set('es', '1');
    const url = `${location.pathname}${p.toString() ? `?${p}` : ''}`;
    history[nueva ? 'pushState' : 'replaceState'](null, '', url);
  }

  function aplicar() {
    const terminos = normalizar(estado.q).split(/\s+/).filter(Boolean);
    const coincide = (f) =>
      terminos.every((t) => f.q.includes(t)) &&
      (!estado.plataformas.length || estado.plataformas.includes(f.pl)) &&
      (!estado.gratis || f.g) &&
      (!estado.es || f.es);

    let total = 0;
    for (const grupo of grupos) {
      let n = 0;
      for (const f of grupo.filas) {
        const ok = coincide(f);
        f.tr.hidden = !ok;
        if (ok) n += 1;
      }
      grupo.n.textContent = n;
      grupo.tbody.hidden = n === 0;
      total += n;
    }

    const hayFiltros = terminos.length > 0 || estado.plataformas.length > 0 || estado.gratis || estado.es;
    const todas = grupos.reduce((suma, g) => suma + g.filas.length, 0);
    conteo.textContent = `${total} ${total === 1 ? 'enlace' : 'enlaces'}${hayFiltros ? ` de ${todas}` : ''}`;
    vacio.hidden = total > 0;
    tabla.hidden = total === 0;
    raiz.querySelectorAll('[data-kc-dv-limpiar]').forEach((b) => {
      if (b.closest('[data-kc-dv-vacio]')) return;
      b.hidden = !hayFiltros;
    });

    // Controles en sincronía con el estado (también al usar atrás/adelante)
    if (buscar.value.trim() !== estado.q) buscar.value = estado.q;
    form.querySelectorAll('[name="plataforma"]').forEach((i) => (i.checked = estado.plataformas.includes(i.value)));
    form.querySelector('[name="gratis"]').checked = estado.gratis;
    form.querySelector('[name="es"]').checked = estado.es;
  }

  form.addEventListener('change', (evento) => {
    const { name, value, checked } = evento.target;
    if (name === 'plataforma') {
      estado.plataformas = checked
        ? [...estado.plataformas, value]
        : estado.plataformas.filter((v) => v !== value);
    } else if (name === 'gratis' || name === 'es') {
      estado[name] = checked;
    } else {
      return;
    }
    escribirURL(true);
    aplicar();
  });

  let espera;
  buscar.addEventListener('input', () => {
    clearTimeout(espera);
    espera = setTimeout(() => {
      estado.q = buscar.value.trim();
      escribirURL(false);
      aplicar();
    }, 180);
  });

  raiz.addEventListener('click', (evento) => {
    if (!evento.target.closest('[data-kc-dv-limpiar]')) return;
    Object.assign(estado, { q: '', plataformas: [], gratis: false, es: false });
    escribirURL(true);
    aplicar();
    buscar.focus();
  });

  window.addEventListener('popstate', () => {
    leerURL();
    aplicar();
  });

  leerURL();
  aplicar();
})();
